import { render } from "./UserCenterIndex.vue?vue&type=template&id=c5d33082&scoped=true"
import script from "./UserCenterIndex.vue?vue&type=script&lang=js"
export * from "./UserCenterIndex.vue?vue&type=script&lang=js"

import "./UserCenterIndex.vue?vue&type=style&index=0&id=c5d33082&lang=scss&scoped=true"

import exportComponent from "D:\\work\\code\\tranWorld\\traneasy-reply(易回复官网)\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5d33082"]])

export default __exports__